import React from 'react'
import ShiftExchangeEntryHeader from './ShiftExchangeEntryHeader'

export default function ShiftExchangeEntryForApproval () {
  return (
    <>
      <ShiftExchangeEntryHeader withShiftSiblings withActions />
    </>
  )
}
